/**
 * DesktopPage
 *
 * Settings page for managing machines running Photon Desktop.
 * All devices ever paired are listed here so users can see online status
 * and revoke access for lost or retired machines.
 *
 * Route: /settings/desktop  (all authenticated users)
 */
import SettingsPageShell from "../../components/Settings/SettingsPageShell";
import DeviceManagement from "../../components/Settings/DeviceManagement";

const DesktopPage = () => (
  <SettingsPageShell
    title="Desktop"
    description="Connect and manage machines running Photon Desktop. Revoke access for lost or retired machines."
    maxWidth="4xl"
  >
    <DeviceManagement />
  </SettingsPageShell>
);

export default DesktopPage;